
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    showExcerpt: {
      type: Boolean,
      default: true,
    },
    showLinkText: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    formattedSlug () {
      if (!this.post.type || this.post.type === `page`) {
        return this.post.slug;
      }
      return `/${this.post.type}/${this.post.slug}`;
    },
    excerptLength () {
      return this.$store.state.config.excerpt_lengths.page_index_item;
    },
    excerpt () {
      return this.post.acf && this.post.acf.page_excerpt !== `` ? this.post.acf.page_excerpt
        : this.post.excerpt || false;
    },
  },

};
